/**
 * Query values that describe *where* someone is, rather than *what they typed*.
 * Anything outside this list is treated as free text and has its value dropped.
 */
const STRUCTURAL_PARAMS = new Set([
  'page',
  'sort',
  'order',
  'view',
  'tab',
  'section',
  'status',
  'kind',
  'overdue',
  'runId',
  'run_id',
]);

/**
 * Build the route string stored on a report.
 *
 * Several pages put free-text search into the URL (`?search=`, `?q=`), so a
 * compliance user looking up a caller can have a phone number or email sitting
 * in the address bar. Persisting that verbatim would copy customer data into a
 * new table, which CONTRIBUTING.md forbids. Keys are kept because "they had a
 * search active" is useful to triage; the values are not.
 */
export function redactRoute(pathname: string, search: string): string {
  if (!search || search === '?') return pathname;

  let params: URLSearchParams;
  try {
    params = new URLSearchParams(search);
  } catch {
    return pathname;
  }

  const parts: string[] = [];
  for (const [key, value] of params.entries()) {
    if (!value) parts.push(key);
    else if (STRUCTURAL_PARAMS.has(key)) parts.push(`${key}=${value}`);
    else parts.push(`${key}=<redacted>`);
  }

  return parts.length > 0 ? `${pathname}?${parts.join('&')}` : pathname;
}
